var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c1ad45f7ee3a12d872bda783bab0de956ec79558"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["rockalingua-web@rockalingua"]={id:"c1ad45f7ee3a12d872bda783bab0de956ec79558"};
      